import React, { useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import Select from "components/Form/Select";
import {
	Modal,
	Label,
	Dimmer,
	Loader,
	Segment,
	Button,
	Icon,
	Card,
	Confirm,
	Image as Img,
	Checkbox,
	Message,
	Table,
	Header,
	Grid,
	Divider,
	Popup,
} from "semantic-ui-react";
import servipay from "assets/image/servipay.png";
import sumup from "assets/image/sumup.png";
import cash from "assets/image/cash.jpg";
import moment from "moment";
import * as Yup from "yup";

const PaymentModal = ({
	t,
	open,
	close,
	folderIsDone,
	paid,
	prescriptionStatus,
	costs,
	costsPatient,
	invoices,
	folderId,
	folderPaymentCancel,
	addPayment,
	center,
	folderPaymentRef,
}) => {
	const [paymentOptionsModalLoading, setPaymentOptionsModalLoading] = useState(false);
	const [confirmCancelPaymentOpen, setConfirmCancelPaymentOpen] = useState(false);
	const [confirmCancelPaymentId, setConfirmCancelPaymentId] = useState(0);
	const [addFreeAmount, setAddFreeAmount] = useState(false);
	const [freeAmountValidated, setFreeAmountValidated] = useState(0);
	const [docToDisplay, setDocToDisplay] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const [payments, setPayments] = useState([]);
	const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
	const [selectedFreeAmount, setSelectedFreeAmount] = useState(false);

	const reasonInvoiceOptions = [
		{
			id: 1,
			label: "Pas de moyen de paiement",
		},
		{
			id: 2,
			label: "Exceptionnel : envoi d'une facture pour paiement",
		},
	];

	const schemaValidation = Yup.object().shape({
		invoice_reason: Yup.string().required("Champ requis"),
	});

	const b64toBlob = (b64Data, contentType) => {
		var byteCharacters = atob(b64Data);

		var byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			var slice = byteCharacters.slice(offset, offset + 512),
				byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};

	useEffect(() => {
		amountInChargeSelected();
	}, [payments]);
	useEffect(() => {
		checkAllInvoices();
	}, [invoices]);

	const checkAllInvoices = () => {
		if (invoices.length > 0) {
			let invoicesToPay = invoices.filter(
				(i) =>
					!paid.payments.some(
						(p) =>
							p.invoice_reference === i.reference &&
							+i.amount.toFixed(2) ===
								+paid.payments
									.filter((p) => p.invoice_reference === i.reference)
									.reduce((acc, p) => acc + p.price, 0)
									.toFixed(2)
					)
			);
			setPayments(invoicesToPay);
		}
	};
	const checkToggle = (payment) => {
		if (payments && payments.filter((p) => p.id === payment.id).length > 0) {
			let pList = payments.filter((p) => p.id !== payment.id);
			setPayments(pList);
		} else {
			var p = payments.slice();

			p.push(payment);
			setPayments(p);
		}
	};

	const amountInChargeSelected = () => {
		var sum = payments.reduce(
			(accum, p) =>
				accum +
				+p.amount.toFixed(2) -
				+paid.payments
					.filter((pay) => pay.invoice_reference === p.reference)
					.reduce((accum, pay) => accum + +pay.price.toFixed(2), 0)
					.toFixed(2),
			0
		);
		return sum;
	};

	const totalInCharge = () => {
		return (+amountInvoicesToPay() + +amountToPay()).toFixed(2);
	};

	const amoutAlreadyPaidOnlyInvoice = () => {
		if (paid && paid.payments && paid.payments.length > 0)
			return paid.payments
				.filter((p) => p.source === "toBill")
				.reduce((accum, p) => accum + p.price, 0)
				.toFixed(2);
		return 0;
	};
	const amoutAlreadyPaidOldInvoices = () => {
		if (paid && paid.payments && paid.payments.length > 0)
			return paid.payments
				.filter((p) => p.source !== "toBill" && p.invoice_reference)
				.reduce((accum, p) => accum + p.price, 0)
				.toFixed(2);
		return 0;
	};
	const amoutAlreadyPaidWithoutInvoice = () => {
		if (paid && paid.payments && paid.payments.length > 0)
			return paid.payments
				.filter((p) => p.source !== "toBill")
				.reduce((accum, p) => accum + p.price, 0)
				.toFixed(2);
		return 0;
	};

	const currentAmountAlreadyPaid = (prescriptionId = null) => {
		if (
			paid &&
			paid.payments &&
			paid.payments.some((p) => !p.invoice_reference && (!prescriptionId || (!!prescriptionId && p.prescription === prescriptionId.toString())))
		) {
			let result = paid.payments
				.filter((p) => !p.invoice_reference && (!prescriptionId || (!!prescriptionId && p.prescription === prescriptionId.toString())))
				.reduce((accum, p) => accum + p.price, 0)
				.toFixed(2);
			if (+result > +costsPatient?.toFixed(2)) return +costsPatient?.toFixed(2);
			else return +result;
		}
		return 0;
	};
	const overPayment = () => {
		if (paid && paid.payments && paid.payments.filter((p) => !p.invoice_reference).length > 0) {
			let result = paid.payments
				.filter((p) => !p.invoice_reference)
				.reduce((accum, p) => accum + p.price, 0)
				?.toFixed(2);
			if (+result > +costsPatient?.toFixed(2)) return +(result - +costsPatient?.toFixed(2)).toFixed(2);
		}
		return 0;
	};
	const totalAmountToPay = () => {
		return (+costsPatient?.toFixed(2) + +invoices.reduce((accum, i) => accum + i.amount, 0).toFixed(2)).toFixed(2);
	};
	const totalAmontInvoices = () => {
		return invoices?.reduce((accum, i) => accum + i.amount, 0).toFixed(2);
	};

	const folderToPay = () => {
		return costsPatient?.toFixed(2);
	};
	const amountToPay = () => {
		return (+costsPatient?.toFixed(2) - currentAmountAlreadyPaid())?.toFixed(2);
	};

	const amountInvoicesToPay = () => {
		let result = invoices.reduce(
			(accum, i) =>
				accum +
				(paid.payments.some((pay) => pay.invoice_reference === i.reference)
					? i.amount - paid.payments.filter((pay) => pay.invoice_reference === i.reference).reduce((acc, p) => acc + p.price, 0)
					: i.amount),
			0
		);
		if (result >= 0) return result.toFixed(2);
		return 0.0;
	};
	const amountToPayWithOtherPaymentsSelected = () => {
		if (+freeAmountValidated > 0) return +freeAmountValidated;
		return +(costsPatient?.toFixed(2) - currentAmountAlreadyPaid() + amountInChargeSelected() - +overPayment()).toFixed(2);
	};

	const getPaymentPartition = async (invoiceOnly = false) => {
		let freeAmountValidatedResult = freeAmountValidated;
		let partition = [];
		if (amountToPay() > 0)
			for (let i = 0; i < costs.length; i++) {
				let costAnalysis = costs[i].items?.reduce(
					(totalCosts, costs) => totalCosts + costs?.price_patient + (costs?.price_patient_hn || 0) + (costs?.price_shipping || 0),
					0
				);
				let costActs = costs[i].sampling_acts ? costs[i].sampling_acts?.reduce((totalCosts, act) => (totalCosts += act?.price ?? 0), 0) : 0;
				let currentFolderAmount =
					((costAnalysis ? costAnalysis : 0) + (costActs ? costActs : 0)).toFixed(2) - currentAmountAlreadyPaid(costs[i].prescription_id);
				let cost = 0;
				if (currentFolderAmount > 0) {
					if (freeAmountValidatedResult > 0)
						if (freeAmountValidatedResult > currentFolderAmount) {
							cost = +currentFolderAmount.toFixed(2);
							freeAmountValidatedResult -= +currentFolderAmount.toFixed(2);
						} else {
							cost = freeAmountValidatedResult;
							freeAmountValidatedResult = 0;
						}
					else {
						cost = +((costAnalysis ? costAnalysis : 0) + (costActs ? costActs : 0)).toFixed(2) - currentAmountAlreadyPaid(costs[i].prescription_id);
					}

					let pay = {
						prescription: costs[i].prescription_id,
						cost: cost,
						invoice_reference: null,
					};
					partition.push(pay);
				}

				if (freeAmountValidatedResult <= 0 && freeAmountValidated > 0) break;
			}
		/* costs.map((c) => {
						let costAnalysis = c.items?.reduce(
							(totalCosts, costs) => totalCosts + costs?.price_patient + (costs?.price_patient_hn || 0) + (costs?.price_shipping || 0),
							0
						);
						let costActs = c.sampling_acts ? c.sampling_acts?.reduce((totalCosts, act) => (totalCosts += act?.price ?? 0), 0) : 0;
						let currentFolderAmount = ((costAnalysis ? costAnalysis : 0) + (costActs ? costActs : 0)).toFixed(2) - currentAmountAlreadyPaid();
						let pay = {
							prescription: c.prescription_id,
							cost:
								freeAmountValidatedResult > 0
									? freeAmountValidatedResult >= currentFolderAmount
										? currentFolderAmount
										: freeAmountValidatedResult
									: ((costAnalysis ? costAnalysis : 0) + (costActs ? costActs : 0)).toFixed(2) - currentAmountAlreadyPaid(),
							invoice_reference: null,
						};
						freeAmountValidatedResult -= freeAmountValidatedResult >= currentFolderAmount ? currentFolderAmount : freeAmountValidatedResult;
						return pay;
				  }) */
		if (!invoiceOnly && +freeAmountValidated === 0 && payments.length > 0) {
			let others = payments.map((p) => {
				return {
					prescription: null,
					cost: (
						p.amount -
						paid.payments.filter((pay) => pay.invoice_reference === p.reference).reduce((accum, pay) => accum + pay.price, 0) -
						overPayment()
					).toFixed(2),
					invoice_reference: p.reference,
				};
			});
			partition = partition.concat(others);
		}

		const invoicesToPay = invoices
			.filter(
				(i) =>
					!partition.some((p) => p.invoice_reference === i.reference) &&
					!paid.payments.some(
						(p) =>
							p.invoice_reference === i.reference &&
							+i.amount.toFixed(2) ===
								+paid.payments
									.filter((p) => p.invoice_reference === i.reference)
									.reduce((acc, p) => acc + p.price, 0)
									.toFixed(2)
					)
			)
			.slice()
			.sort((a, b) => moment(a.dossier_date) - moment(b.dossier_date))
			.map((i) => {
				return {
					...i,
					amount: i.amount - paid.payments.filter((p) => p.invoice_reference === i.reference).reduce((acc, p) => +(acc + p.price).toFixed(2), 0),
				};
			});
		if (!invoiceOnly && freeAmountValidatedResult > 0) {
			if (invoicesToPay.length > 0) {
				for (let i = 0; i < invoicesToPay.length; i++) {
					if (invoicesToPay[i].amount < freeAmountValidatedResult) {
						freeAmountValidatedResult -= invoicesToPay[i].amount;
						partition.push({
							prescription: null,
							cost: invoicesToPay[i].amount,
							invoice_reference: invoicesToPay[i].reference,
						});
					} else {
						partition.push({
							prescription: null,
							cost: +freeAmountValidatedResult.toFixed(2),
							invoice_reference: invoicesToPay[i].reference,
						});
						freeAmountValidatedResult = 0;
						break;
					}
				}
			}
			//Par défaut, s'il reste quelque chose on le met sur la 1e prescription du dossier
			if (freeAmountValidatedResult > 0) {
				partition.push({
					prescription: costs.map((c) => c.prescription_id)[0],
					cost: +freeAmountValidatedResult.toFixed(2),
					invoice_reference: null,
				});
				freeAmountValidatedResult = 0;
			}
		}
		return partition;
	};

	const getPaymentsBySource = () => {
		let partielSum = [];
		paid.payments &&
			paid.payments.forEach((payment) => {
				if (
					partielSum.length > 0 &&
					partielSum.some((ps) => ps.invoice_reference === payment.invoice_reference && ps.voucher_code === payment.voucher_code)
				) {
					var ps = partielSum.find((ps) => ps.invoice_reference === payment.invoice_reference && ps.voucher_code === payment.voucher_code);
					ps.price += +payment.price.toFixed(2);
					ps.key = ps.key ? ps.key.toString().concat("-", payment.key) : payment.key;
					(ps.paiements && ps.paiements.length > 0 ? ps.paiements : []).push(payment);
				} else
					partielSum.push({
						key: payment.key,
						price: +payment.price.toFixed(2),
						voucher_code: payment.voucher_code,
						invoice_reference: payment.invoice_reference,
						paiements: [payment],
					});
			});
		return partielSum.slice().sort((a, b) => b.invoice_reference?.localeCompare(a.invoice_reference));
	};
	const getPaymentsByRef = (ref, allRef = false) => {
		let res = getPaymentsBySource().filter((p) =>
			!ref && !allRef ? !p.invoice_reference : allRef ? !!p.invoice_reference : p.invoice_reference === ref
		);
		if (res.length > 0) return res.reduce((acc, r) => acc.concat(r.paiements), []);
		return [];
	};
	const getAllPayments = () => {
		return getPaymentsBySource().reduce((acc, r) => acc.concat(r.paiements), []);
	};

	const confirmInvoicePayment = async (values) => {
		setPaymentOptionsModalLoading(true);
		addPayment("invoice", folderId, null, +amountToPay(), true, null, await getPaymentPartition(true), {
			reason: reasonInvoiceOptions.find((r) => r.id === values.invoice_reason)
				? reasonInvoiceOptions.find((r) => r.id === values.invoice_reason).label
				: null,
			comment: values.invoice_reason_comment,
		}).then(() => {
			setPaymentOptionsModalLoading(false);
			setOpenInvoiceModal(false);
			setPayments([]);
		});
	};
	return (
		<>
			<Modal
				open={open}
				onClose={close}
				closeOnEscape
				closeOnDimmerClick
				size={folderIsDone || (+amountToPay() === 0 && invoices.length === 0) ? "small" : invoices.length > 0 ? "fullscreen" : "large"}
			>
				<Modal.Header>{t("folderManager.paimentSolutions")}</Modal.Header>

				<Modal.Content>
					<Dimmer active={paymentOptionsModalLoading}>
						<Loader size="big">{t("folderManager.processing")}</Loader>
					</Dimmer>
					<Grid>
						<Grid.Column floated="left" computer={folderIsDone || (invoices.length === 0 && +amountToPay() === 0) ? 16 : 4} tablet={4} mobile={16}>
							{invoices.length > 0 && (
								<Header as="h4" attached="top" style={{ backgroundColor: "rgb(0, 116, 228)", color: "white" }}>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "baseline",
											flexDirection: "column",
										}}
									>
										<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}>
											<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>Montant total à encaisser</span>

											<span>
												<Label size="small">{totalAmountToPay()} € </Label>{" "}
											</span>
										</div>
										<Divider horizontal />
										{amoutAlreadyPaidOnlyInvoice() > 0 && (
											<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}>
												<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- FACTURE A ENVOYER</span>
												<Label size="small">{amoutAlreadyPaidOnlyInvoice()} € </Label>
											</div>
										)}
										<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}>
											<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- MONTANT ENCAISSé</span>
											<Label size="small">{amoutAlreadyPaidWithoutInvoice()} € </Label>
										</div>
										{+totalInCharge() >= 0 && (
											<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}>
												<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- Reste à encaisser</span>
												<Label size="small" color={+totalInCharge() > 0 ? "red" : ""}>
													{totalInCharge()} €{" "}
												</Label>
											</div>
										)}
										{+overPayment() > 0 && (
											<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}>
												<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- TROP perçu</span>
												<Label size="small" color="orange">
													{overPayment().toFixed(2)} €{" "}
												</Label>
											</div>
										)}
									</div>
								</Header>
							)}
							<Header as="h5" attached="top" style={{ backgroundColor: "rgb(0, 116, 228)", color: "white" }}>
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "column" }}>
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}>
										<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>
											DOSSIER EN COURS{" "}
											{getPaymentsByRef().length > 0 && (
												<Popup
													position="right center"
													content={
														<>
															<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>Enregistrements</span>

															{getPaymentsByRef()?.map((p, index) => (
																<PaiementLabel
																	key={`-folder-${index}`}
																	p={p}
																	done={folderIsDone}
																	t={t}
																	setConfirmCancelPaymentOpen={setConfirmCancelPaymentOpen}
																	setConfirmCancelPaymentId={setConfirmCancelPaymentId}
																/>
															))}
														</>
													}
													trigger={<Icon name="info circle" />}
													pinned
													hoverable
												/>
											)}
										</span>
										<Label size="small">{folderToPay()} € </Label>
									</div>
									<Divider horizontal />
									{+folderToPay() >= 0 && (
										<>
											{getPaymentsByRef().length === 0 && (
												<div
													style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}
												>
													<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- MONTANT ENCAISSé</span>
													<Label> 0.00 €</Label>
												</div>
											)}
											{getPaymentsByRef().filter((p) => p.source === "toBill").length > 0 && (
												<div
													style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}
												>
													<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- Envoi facture</span>
													<Label color={"teal"}>
														{getPaymentsByRef()
															.filter((p) => p.source === "toBill")
															.reduce((acc, p) => acc + p.price, 0)
															.toFixed(2)}{" "}
														€
													</Label>
												</div>
											)}
											{getPaymentsByRef().filter((p) => p.source !== "toBill").length > 0 && (
												<div
													style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}
												>
													<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- MONTANT ENCAISSé</span>
													<Label color={"teal"}>
														{getPaymentsByRef()
															.filter((p) => p.source !== "toBill")
															.reduce((acc, p) => acc + p.price, 0)
															.toFixed(2)}{" "}
														€
													</Label>
												</div>
											)}

											{+amountToPay() >= 0 && (
												<div
													style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}
												>
													<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- Reste à encaisser</span>
													<Label color={+amountToPay() > 0 ? "red" : "grey"}>{amountToPay()} €</Label>
												</div>
											)}

											{+overPayment() > 0 && (
												<div
													style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}
												>
													<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- TROP perçu</span>
													<Label size="small" color="orange">
														{overPayment().toFixed(2)} €{" "}
													</Label>
												</div>
											)}
										</>
									)}
								</div>
							</Header>

							{(invoices.length > 0 || paid.payments.some((p) => !p.prescription)) && (
								<Header as="h5" attached="top" style={{ backgroundColor: "rgb(0, 116, 228)", color: "white", marginTop: "1px" }}>
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: "row", width: "100%" }}>
										<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>Anciennes factures </span>
										{+totalAmontInvoices() > 0 && <Label size="small">{totalAmontInvoices()} € </Label>}
									</div>
									<Divider horizontal />
									{+folderToPay() >= 0 && (
										<>
											{amoutAlreadyPaidOldInvoices() >= 0 && (
												<div
													style={{
														display: "flex",
														justifyContent: "space-between",
														alignItems: "baseline",
														flexDirection: "row",
														width: "100%",
													}}
												>
													<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>
														- MONTANT ENCAISSé{" "}
														{getPaymentsByRef(null, true).length > 0 && (
															<Popup
																content={
																	<>
																		<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>Paiements enregistrés</span>
																		{getPaymentsByRef(null, true)?.map((p, index) => (
																			<PaiementLabel
																				key={`-folder-${index}`}
																				p={p}
																				done={folderIsDone}
																				t={t}
																				setConfirmCancelPaymentOpen={setConfirmCancelPaymentOpen}
																				setConfirmCancelPaymentId={setConfirmCancelPaymentId}
																			/>
																		))}
																	</>
																}
																trigger={<Icon name="info circle" />}
																pinned
																hoverable
															/>
														)}
													</span>
													<Label color={amoutAlreadyPaidOldInvoices() > 0 ? "teal" : ""}>{amoutAlreadyPaidOldInvoices()} €</Label>
												</div>
											)}
											{invoices.length > 0 && +amountInvoicesToPay() >= 0 && (
												<div
													style={{
														display: "flex",
														justifyContent: "space-between",
														alignItems: "baseline",
														flexDirection: "row",
														width: "100%",
													}}
												>
													<span style={{ textTransform: "uppercase", fontSize: "0.8rem" }}>- Reste à encaisser</span>
													<Label color={amountInvoicesToPay() > 0 ? "red" : ""}>{amountInvoicesToPay()} €</Label>
												</div>
											)}
										</>
									)}
								</Header>
							)}
						</Grid.Column>
						{!folderIsDone && (
							<Grid.Column computer={invoices.length === 0 && +amountToPay() === 0 ? 16 : 12} tablet={12} mobile={16}>
								<>
									{invoices && invoices.length > 0 && (
										<>
											<Header as="h5" attached="top" style={{ backgroundColor: "rgb(0, 116, 228)", color: "white" }}>
												<div style={{ display: "flex", justifyContent: "space-between" }}>
													<span style={{ textTransform: "uppercase" }}>{invoices.length > 1 ? "Anciennes factures" : "Ancienne facture"}</span>
												</div>
												{!folderIsDone && (
													<Message warning>
														<Message.Header>
															Profitez de son passage pour lui demander de régler{" "}
															{invoices.length > 1 ? "les montants impayés." : "le montant impayé."}
														</Message.Header>
													</Message>
												)}
											</Header>

											<Segment attached>
												<Table basic="very" celled>
													<Table.Header>
														<Table.Row>
															<Table.HeaderCell></Table.HeaderCell>
															<Table.HeaderCell>Montant</Table.HeaderCell>
															<Table.HeaderCell>Dossier</Table.HeaderCell>
															<Table.HeaderCell>Facture</Table.HeaderCell>
															<Table.HeaderCell>Rappel 1</Table.HeaderCell>
															<Table.HeaderCell>Rappel 2</Table.HeaderCell>
															<Table.HeaderCell>Rappel 3</Table.HeaderCell>
															<Table.HeaderCell>Paiements encaissés</Table.HeaderCell>
														</Table.Row>
													</Table.Header>
													<Table.Body>
														{invoices &&
															invoices.length > 0 &&
															invoices
																.slice()
																.sort((a, b) => moment(a.dossier_date) - moment(b.dossier_date))
																.map((i, index) => (
																	<Table.Row key={`row-${index}`}>
																		<Table.Cell
																			textAlign="right"
																			onClick={() => {
																				if (freeAmountValidated > 0) setFreeAmountValidated(0);
																				setSelectedFreeAmount(false);
																			}}
																		>
																			{!folderIsDone &&
																				!selectedFreeAmount &&
																				paid.payments.filter((p) => p.invoice_reference === i.reference).length === 0 && (
																					<Checkbox
																						style={{ padding: "4px", marginRight: "8px" }}
																						checked={payments && payments.some((p) => p.id === i.id)}
																						onChange={(e) => checkToggle(i, e)}
																					/>
																				)}
																			{paid.payments
																				.filter((p) => p.invoice_reference === i.reference)
																				.reduce((acc, p) => acc + p.price, 0)
																				?.toFixed(2) === i.amount?.toFixed(2) && <Icon color="green" name="check" />}
																			{paid.payments.filter((p) => p.invoice_reference === i.reference).length > 0 &&
																				paid.payments
																					.filter((p) => p.invoice_reference === i.reference)
																					.reduce((acc, p) => acc + p.price, 0)
																					?.toFixed(2) !== i.amount?.toFixed(2) && (
																					<>
																						{" "}
																						<Icon color="orange" name="hand point right" />
																						{"Paiement partiel, reste à payer :"}
																						<br />
																					</>
																				)}

																			{paid.payments
																				.filter((p) => p.invoice_reference === i.reference)
																				.reduce((acc, p) => acc + p.price, 0)
																				?.toFixed(2) !== i.amount?.toFixed(2) &&
																				paid.payments.filter((p) => p.invoice_reference === i.reference).reduce((acc, p) => acc + p.price, 0) > 0 && (
																					<>
																						{!folderIsDone && !selectedFreeAmount && (
																							<Checkbox
																								style={{ padding: "4px", marginRight: "40px" }}
																								checked={payments && payments.some((p) => p.id === i.id)}
																								onChange={(e) => checkToggle(i, e)}
																							/>
																						)}
																						{folderIsDone && "Reste à payer : "}
																						{`${(
																							i.amount -
																							paid.payments.filter((p) => p.invoice_reference === i.reference).reduce((acc, p) => acc + p.price, 0)
																						).toFixed(2)} €`}
																					</>
																				)}
																		</Table.Cell>
																		<Table.Cell>{i.amount?.toFixed(2)} €</Table.Cell>
																		<Table.Cell>
																			{i.dossier_date && moment(i.dossier_date).format("DD/MM/YYYY")}
																			<br />
																			<span style={{ fontSize: "0.8rem", marginLeft: "4px" }}>{i.reference}</span>
																		</Table.Cell>
																		<Table.Cell>
																			{i.invoice_date && moment(i.invoice_date).format("DD/MM/YYYY")}
																			{i.last_invoice_pdf && (
																				<Button
																					style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																					onClick={(e) => {
																						if (e !== undefined) e.preventDefault();
																						setDocToDisplay(i.last_invoice_pdf);
																						setOpenModal(true);
																					}}
																				>
																					<Icon name="file pdf" style={{ margin: 0 }} />
																				</Button>
																			)}
																			{!i.reminder2_date && !i.reminder3_date && !i.reminder1_date && i.pdf && (
																				<Button
																					style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																					onClick={(e) => {
																						if (e !== undefined) e.preventDefault();
																						setDocToDisplay(i.pdf);
																						setOpenModal(true);
																					}}
																				>
																					<Icon name="file pdf" style={{ margin: 0 }} />
																				</Button>
																			)}
																		</Table.Cell>
																		<Table.Cell>
																			{i.reminder1_date && moment(i.reminder1_date).format("DD/MM/YYYY")}
																			{!i.reminder2_date && !i.reminder3_date && i.reminder1_date && i.pdf && (
																				<Button
																					style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																					onClick={(e) => {
																						if (e !== undefined) e.preventDefault();
																						setDocToDisplay(i.pdf);
																						setOpenModal(true);
																					}}
																				>
																					<Icon name="file pdf" style={{ margin: 0 }} />
																				</Button>
																			)}
																		</Table.Cell>
																		<Table.Cell>
																			{i.reminder2_date && moment(i.reminder2_date).format("DD/MM/YYYY")}
																			{i.reminder2_date && !i.reminder3_date && i.pdf && (
																				<Button
																					style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																					onClick={(e) => {
																						if (e !== undefined) e.preventDefault();
																						setDocToDisplay(i.pdf);
																						setOpenModal(true);
																					}}
																				>
																					<Icon name="file pdf" style={{ margin: 0 }} />
																				</Button>
																			)}
																		</Table.Cell>
																		<Table.Cell>
																			{i.reminder3_date && moment(i.reminder3_date).format("DD/MM/YYYY")}
																			{i.reminder3_date && i.pdf && (
																				<Button
																					style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																					onClick={(e) => {
																						if (e !== undefined) e.preventDefault();
																						setDocToDisplay(i.pdf);
																						setOpenModal(true);
																					}}
																				>
																					<Icon name="file pdf" style={{ margin: 0 }} />
																				</Button>
																			)}
																		</Table.Cell>
																		<Table.Cell>
																			{getPaymentsByRef(i.reference)?.map((p, index) => (
																				<PaiementLabel
																					key={`${i.reference}-${index}`}
																					p={p}
																					done={folderIsDone}
																					t={t}
																					setConfirmCancelPaymentOpen={setConfirmCancelPaymentOpen}
																					setConfirmCancelPaymentId={setConfirmCancelPaymentId}
																				/>
																			))}
																		</Table.Cell>
																	</Table.Row>
																))}
													</Table.Body>
													<Table.Footer fullWidth>
														{selectedFreeAmount === 0 && amountInChargeSelected() > 0 && (
															<Table.Row>
																<Table.HeaderCell colSpan="8">
																	<div style={{ display: "flex", alignItems: "baseline" }}>
																		<>
																			<Label color="orange">{amountInChargeSelected().toFixed(2)} €</Label>
																			<>- {t("folderManager.AmountToBeCollectedOld")}</>
																		</>
																	</div>
																</Table.HeaderCell>
															</Table.Row>
														)}
													</Table.Footer>
												</Table>
											</Segment>
										</>
									)}

									{!folderIsDone && invoices.length >= 0 && +amountToPay() > 0 && (
										<Segment>
											{+overPayment() > 0 && amountToPayWithOtherPaymentsSelected().toFixed(2) !== freeAmountValidated.toFixed(2) && (
												<div>
													<Label>{`- ${+overPayment().toFixed(2)} €`}</Label> - Trop perçu
												</div>
											)}
											{folderToPay() > 0 && +amountToPay() > 0 && (
												<div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}>
													<div>
														<Label color="red">{folderToPay()} €</Label>
														<> - {t("folderManager.AmountFolderToBeCollectedOld")} </>
													</div>
													{center?.invoicesAvailable && (
														<Button style={{ marginLeft: "6px" }} onClick={() => setOpenInvoiceModal(true)}>
															Non-encaissement motif
														</Button>
													)}
												</div>
											)}
											{+amountToPay() === 0 && (
												<>
													{getAllPayments()?.map((p, index) => (
														<PaiementLabel
															key={`-folder-${index}`}
															p={p}
															done={folderIsDone}
															t={t}
															setConfirmCancelPaymentOpen={setConfirmCancelPaymentOpen}
															setConfirmCancelPaymentId={setConfirmCancelPaymentId}
														/>
													))}
												</>
											)}
										</Segment>
									)}
								</>

								<Header as="h5" attached="top" style={{ backgroundColor: "rgb(0, 116, 228)", color: "white" }}>
									<div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", width: "100%" }}>
										<span style={{ textTransform: "uppercase" }}>Encaissement </span>
										{!selectedFreeAmount && (
											<Button
												onClick={(e) => {
													e.preventDefault();
													setSelectedFreeAmount(!selectedFreeAmount);

													if (freeAmountValidated > 0) setFreeAmountValidated(0);

													setAddFreeAmount(!selectedFreeAmount);
													setPayments([]);
												}}
											>
												Encaisser un montant libre
											</Button>
										)}
										{selectedFreeAmount && (
											<Formik
												initialValues={{
													freeAmountForm: "",
												}}
												onSubmit={(values) => {
													if (values.freeAmountForm === "") return;
													const amount = +values.freeAmountForm.toString()?.replace(",", ".");
													setAddFreeAmount(false);
													setFreeAmountValidated(amount);
												}}
											>
												{({ setFieldValue, values }) => {
													return (
														<Form>
															{!!selectedFreeAmount && (
																<div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
																	<>
																		{addFreeAmount && (
																			<div
																				style={{
																					minWidth: "100px",
																					display: "flex",
																					alignItems: "baseline",
																					justifyContent: "center",
																				}}
																			>
																				<div style={{ width: "100px", minWidth: "100px", fontSize: "0.8em" }}>
																					<Field
																						type="text"
																						name="freeAmountForm"
																						placeholder="Montant libre"
																						component={CustomInputTextComponent}
																						autoFocus
																						autoComplete="off"
																					/>
																				</div>
																				<Icon
																					name="check"
																					onClick={() => {
																						if (values.freeAmountForm) setAddFreeAmount(false);
																						setFreeAmountValidated(+values.freeAmountForm.toString()?.replace(",", "."));
																					}}
																					style={{ cursor: "pointer", fontSize: "1.2em", marginLeft: "10px" }}
																				/>
																			</div>
																		)}
																	</>
																</div>
															)}
														</Form>
													);
												}}
											</Formik>
										)}
									</div>
								</Header>
								{(freeAmountValidated > 0 ||
									+amountToPayWithOtherPaymentsSelected().toFixed(2) > 0 ||
									(+overPayment() > 0 && payments.length > 0)) && (
									<Segment attached>
										<>
											{freeAmountValidated > 0 && (
												<div style={{ display: "flex", alignItems: "baseline" }}>
													<>
														<Label color="orange" style={{ display: "flex", flexDirection: "row", justifyContent: "center", height: "26px" }}>
															{freeAmountValidated && +freeAmountValidated > 0 ? (+freeAmountValidated).toFixed(2) : 0} €
															{!!freeAmountValidated && +freeAmountValidated > 0 && (
																<Icon
																	name="delete"
																	onClick={() => {
																		setFreeAmountValidated(0);
																		setSelectedFreeAmount(false);
																	}}
																/>
															)}
															<Label.Detail
																as="a"
																onClick={() => {
																	//setFieldValue("freeAmountForm", +freeAmountValidated > 0 ? freeAmountValidated : "");
																	setAddFreeAmount(true);
																}}
															>
																Modifier
															</Label.Detail>
														</Label>
														<> - Montant libre </>
													</>
												</div>
											)}
											{+overPayment() > 0 && payments.length > 0 && (
												<div>
													<Label color="green">{+overPayment()} €</Label> - Trop perçu{" "}
												</div>
											)}
											{+amountToPayWithOtherPaymentsSelected().toFixed(2) > 0 && (
												<div>
													<Label color="black">{amountToPayWithOtherPaymentsSelected().toFixed(2)} €</Label> -{" "}
													{t("folderManager.AmountToBeCollectedAll")}{" "}
												</div>
											)}
										</>
										{!folderIsDone && +amountToPayWithOtherPaymentsSelected().toFixed(2) <= 0 && +overPayment() > 0 && payments.length > 0 && (
											<>
												<Divider />
												<Card>
													<Card.Content>
														<Card.Header>Trop perçu</Card.Header>
													</Card.Content>
													<Card.Content extra>
														<Button
															compact
															onClick={async (e) => {
																if (e !== undefined) e.preventDefault();
																await folderPaymentRef(
																	folderId,
																	paid?.payments?.filter((p) => !p.invoice_reference)[0].key,
																	payments[0].reference,

																	+overPayment() >=
																		+(
																			payments[0].amount -
																			+paid.payments
																				.filter((pay) => pay.invoice_reference === payments[0].reference)
																				.reduce((acc, pay) => acc + pay.price, 0)
																				.toFixed(2)
																		)
																		? {
																				folder: folderToPay(),
																				charge: (
																					payments[0].amount -
																					+paid.payments
																						.filter((pay) => pay.invoice_reference === payments[0].reference)
																						.reduce((acc, pay) => acc + pay.price, 0)
																						.toFixed(2)
																				).toFixed(2),
																		  }
																		: null
																).then(() => {
																	if (freeAmountValidated > 0) setFreeAmountValidated(0);
																	setSelectedFreeAmount(false);
																	setPayments([]);
																	setPaymentOptionsModalLoading(false);
																});
															}}
														>
															Utiliser le trop perçu de {+overPayment().toFixed(2)} € sur la première facture sélectionnée
														</Button>
													</Card.Content>
												</Card>
											</>
										)}
										{amountToPayWithOtherPaymentsSelected() > 0 && !folderIsDone && (
											<>
												<Divider />
												<Card.Group itemsPerRow={3}>
													{center?.servipayAvailable && (
														<Card>
															<Card.Content>
																<Img floated="right" size="mini" src={servipay} />
																<Card.Header>Servipay</Card.Header>
															</Card.Content>
															<Card.Content extra>
																<Button
																	compact
																	onClick={async (e) => {
																		if (e !== undefined) e.preventDefault();
																		setPaymentOptionsModalLoading(true);
																		if (overPayment() > 0 && payments.length > 0) {
																			await folderPaymentRef(
																				folderId,
																				paid?.payments?.filter((p) => !p.invoice_reference)[0].key,
																				payments[0].reference,

																				+overPayment() <
																					+(
																						payments[0].amount -
																						+paid.payments
																							.filter((pay) => pay.invoice_reference === payments[0].reference)
																							.reduce((acc, pay) => acc + pay.price, 0)
																							.toFixed(2)
																					)
																					? {
																							folder: folderToPay(),
																							charge: +overPayment(),
																					  }
																					: null
																			);
																		}
																		addPayment(
																			"servipay",
																			folderId,
																			null,
																			amountToPayWithOtherPaymentsSelected().toFixed(2),
																			true,
																			null,
																			await getPaymentPartition()
																		).then(() => {
																			if (freeAmountValidated > 0) setFreeAmountValidated(0);
																			setSelectedFreeAmount(false);
																			setPayments([]);
																			setPaymentOptionsModalLoading(false);
																		});
																	}}
																>
																	{t("folderManager.confirmServipay", { amountToPay: amountToPayWithOtherPaymentsSelected().toFixed(2) })}
																</Button>
															</Card.Content>
														</Card>
													)}
													{center?.cashAvailable && (
														<Card>
															<Card.Content>
																<Img src={cash} floated="right" size="mini" />
																<Card.Header>{t("folderManager.cash")}</Card.Header>
															</Card.Content>
															<Card.Content extra>
																<Button
																	compact
																	onClick={async (e) => {
																		if (e !== undefined) e.preventDefault();
																		setPaymentOptionsModalLoading(true);
																		if (overPayment() > 0 && payments.length > 0) {
																			await folderPaymentRef(
																				folderId,
																				paid?.payments?.filter((p) => !p.invoice_reference)[0].key,
																				payments[0].reference,

																				+overPayment() <
																					+(
																						payments[0].amount -
																						+paid.payments
																							.filter((pay) => pay.invoice_reference === payments[0].reference)
																							.reduce((acc, pay) => acc + pay.price, 0)
																							.toFixed(2)
																					)
																					? {
																							folder: folderToPay(),
																							charge: +overPayment(),
																					  }
																					: null
																			);
																		}
																		addPayment(
																			"cash",
																			folderId,
																			null,
																			amountToPayWithOtherPaymentsSelected().toFixed(2),
																			true,
																			null,
																			await getPaymentPartition()
																		).then(() => {
																			if (freeAmountValidated > 0) setFreeAmountValidated(0);
																			setSelectedFreeAmount(false);
																			setPaymentOptionsModalLoading(false);
																			setPayments([]);
																		});
																	}}
																>
																	{t("folderManager.confirmCash", { amountToPay: amountToPayWithOtherPaymentsSelected().toFixed(2) })}
																</Button>
															</Card.Content>
														</Card>
													)}
													{center?.sumupAvailable && (
														<Card>
															<Card.Content>
																<Img src={sumup} floated="right" size="mini" />
																<Card.Header>Sumup</Card.Header>
															</Card.Content>
															<Card.Content extra>
																<Button
																	compact
																	onClick={async (e) => {
																		if (e !== undefined) e.preventDefault();
																		setPaymentOptionsModalLoading(true);
																		if (overPayment() > 0 && payments.length > 0) {
																			await folderPaymentRef(
																				folderId,
																				paid?.payments?.filter((p) => !p.invoice_reference)[0].key,
																				payments[0].reference,

																				+overPayment() <
																					+(
																						payments[0].amount -
																						+paid.payments
																							.filter((pay) => pay.invoice_reference === payments[0].reference)
																							.reduce((acc, pay) => acc + pay.price, 0)
																							.toFixed(2)
																					)
																					? {
																							folder: folderToPay(),
																							charge: +overPayment(),
																					  }
																					: null
																			);
																		}
																		addPayment(
																			"sumup",
																			folderId,
																			null,
																			amountToPayWithOtherPaymentsSelected().toFixed(2),
																			true,
																			null,
																			await getPaymentPartition()
																		).then(() => {
																			if (freeAmountValidated > 0) setFreeAmountValidated(0);
																			setSelectedFreeAmount(false);
																			setPaymentOptionsModalLoading(false);
																			setPayments([]);
																		});
																	}}
																>
																	{t("folderManager.confirmSumup", { amountToPay: amountToPayWithOtherPaymentsSelected().toFixed(2) })}
																</Button>
															</Card.Content>
														</Card>
													)}
												</Card.Group>
											</>
										)}
									</Segment>
								)}
							</Grid.Column>
						)}
					</Grid>
				</Modal.Content>

				<Modal.Actions>
					{!folderIsDone && paid.payments.length > 0 && confirmCancelPaymentId > 0 && (
						<>
							<Confirm
								open={confirmCancelPaymentOpen}
								content={t("folderManager.cancelPayment")}
								cancelButton={t("folderManager.no")}
								confirmButton={t("folderManager.yes")}
								onCancel={(e) => {
									if (e !== undefined) e.preventDefault();
									setConfirmCancelPaymentOpen(false);
									setConfirmCancelPaymentId(0);
								}}
								onConfirm={(e) => {
									if (e !== undefined) e.preventDefault();
									folderPaymentCancel(folderId, confirmCancelPaymentId);
									setConfirmCancelPaymentOpen(false);
									setConfirmCancelPaymentId(0);
								}}
							/>
						</>
					)}
					<Button content={t("folderManager.close")} onClick={() => close()} />
				</Modal.Actions>
			</Modal>
			<Modal
				open={openModal}
				size="large"
				closeOnEscape
				closeOnDimmerClick
				onClose={() => {
					setOpenModal(false);
					setDocToDisplay(null);
				}}
			>
				<Modal.Header>Document en attente de paiement</Modal.Header>
				<Modal.Content style={{ maxHeight: "75vh" }}>
					{docToDisplay && (
						<iframe
							id="fraDisabled"
							//Prevent download
							src={URL.createObjectURL(b64toBlob(docToDisplay, "application/pdf")) + "#toolbar=0"}
							title={"Facture en attente"}
							name={"Facture en attente"}
							style={{ width: "100%", height: "73vh" }}
						></iframe>
					)}
				</Modal.Content>
				<Modal.Actions>
					<Button
						content="Fermer"
						onClick={() => {
							setOpenModal(false);
							setDocToDisplay(null);
						}}
					/>
				</Modal.Actions>
			</Modal>
			<Modal open={openInvoiceModal} size="tiny" closeOnEscape closeOnDimmerClick>
				<Modal.Header>Motif de non-encaissement</Modal.Header>
				<Formik
					enableReinitialize
					initialValues={{
						invoice_reason: "",
						invoice_reason_comment: "",
					}}
					validationSchema={schemaValidation}
				>
					{({ values }) => (
						<>
							<Modal.Content>
								<Form>
									<Field
										component={Select}
										name="invoice_reason"
										customlabel="Veuillez sélectionner la raison de la demande de facture."
										placeholder="Raison de la facture"
										options={reasonInvoiceOptions.map((option) => {
											return {
												value: option.id,
												label: option.label,
											};
										})}
									/>
								</Form>
							</Modal.Content>

							<Modal.Actions>
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										setOpenInvoiceModal(false);
									}}
								>
									Annuler
								</Button>
								<Button
									primary
									onClick={async (e) => {
										if (e !== undefined) e.preventDefault();
										await confirmInvoicePayment(values);
										setOpenInvoiceModal(false);
									}}
									disabled={values.invoice_reason === ""}
								>
									Confirmer
								</Button>
							</Modal.Actions>
						</>
					)}
				</Formik>
			</Modal>
		</>
	);
};

const PaiementLabel = ({ keyId, p, t, done, setConfirmCancelPaymentOpen, setConfirmCancelPaymentId }) => {
	return (
		<Label key={`paiement-${keyId}`}>
			{p.price?.toFixed(2)} €
			<Label.Detail>
				{p.source === "toBill"
					? t("folderManager.toBill")
					: p.source === "stripe"
					? t("folderManager.stripe")
					: p.source === "voucher"
					? t("folderManager.voucher", { voucherCode: p.voucher_code })
					: p.source === "servipay"
					? t("folderManager.servipay")
					: p.source === "especes"
					? t("folderManager.cash")
					: p.source}
			</Label.Detail>
			{!done && (
				<Icon
					onClick={() => {
						setConfirmCancelPaymentOpen(true);
						setConfirmCancelPaymentId(p.key);
					}}
					name="delete"
				/>
			)}
		</Label>
	);
};

export default PaymentModal;
